export default __webpack_public_path__ + "static/media/forgot.df9efd81.svg";